import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import 'lib-flexible'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/main.css';
import voca from "voca";
import enLocale from "element-ui/lib/locale/lang/en";
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
import locale from "element-ui/lib/locale";
import Directives from './directives/index'
Vue.use(Directives)

import '@/util/xdate'

// 字符串处理类库
window.v = voca;

//---------------------中英文切换-------------------

import VueI18n from 'vue-i18n'
Vue.use(VueI18n) // 挂载
Vue.use(ElementUI, { i18n: (key, value) => i18n.t(key, value) });
const i18n = new VueI18n({
    locale: localStorage.getItem('languageSet') || 'en-US', // 语言标识
    messages: {
        'zh-CN': {...require('./language/zh'), ...zhLocale, }, // 通过require引入中文语言包
        'en-US': {...require('./language/en'), ...enLocale } // 通过require引入英文语言包
    }
})

Vue.prototype.$bus = new Vue()

// Vue.use(ElementUI);

Vue.config.productionTip = false

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')